import { c as _c } from "react/compiler-runtime";
import { AuthorAvatar } from '@cc-shopping/ui/composites/AuthorAvatar';
import { SocialMediaLink } from '@cc-shopping/ui/composites/SocialMediaLink';
import { LogoBadge as Badge } from '@cc-shopping/ui/primitives/Logo';
import { Box, Link, List, ListItem, Typography } from '@mui/material';
import { BadgeIcon } from './Icons/BadgeIcon';
import type { AuthorTooltipProps } from './types';
const READ_FULL_PROFILE = 'See full bio';
interface AuthorTooltipContentProps extends Omit<AuthorTooltipProps, 'children' | 'variant'> {
  maxWidth?: string;
}
export function AuthorTooltipContent(t0) {
  const $ = _c(52);
  const {
    name,
    link,
    bio,
    avatarMiniatureURL,
    socialMediaLinks,
    userPage,
    maxWidth: t1,
    Renderer
  } = t0;
  const maxWidth = t1 === undefined ? "188px" : t1;
  let T0;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== avatarMiniatureURL || $[1] !== maxWidth || $[2] !== name || $[3] !== userPage?.experience || $[4] !== userPage?.jobTitle) {
    const userExperiences = userPage?.experience?.split(",").map(_temp);
    T0 = Box;
    t2 = "author-tooltip-content";
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = {
        display: "flex",
        flexDirection: "column",
        pb: 3,
        gap: 2,
        flexWrap: "wrap",
        textWrap: "wrap"
      };
      $[10] = t3;
    } else {
      t3 = $[10];
    }
    let t6;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = {
        display: "flex",
        alignItems: "center",
        mb: 2,
        gap: 3
      };
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    let t7;
    if ($[12] !== avatarMiniatureURL || $[13] !== name) {
      t7 = avatarMiniatureURL ? <AuthorAvatar sizeVariant="extraLarge" src={avatarMiniatureURL} alt={name} /> : <Box sx={{
        width: 55,
        height: 55,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        border: "1px solid white",
        bgcolor: "grey.100",
        borderRadius: "50%"
      }}><Badge /></Box>;
      $[12] = avatarMiniatureURL;
      $[13] = name;
      $[14] = t7;
    } else {
      t7 = $[14];
    }
    let t8;
    if ($[15] !== maxWidth) {
      t8 = {
        display: "flex",
        flexDirection: "column",
        maxWidth
      };
      $[15] = maxWidth;
      $[16] = t8;
    } else {
      t8 = $[16];
    }
    let t9;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = {
        color: "text.primary"
      };
      $[17] = t9;
    } else {
      t9 = $[17];
    }
    let t10;
    if ($[18] !== name) {
      t10 = <Typography variant="textBold" sx={t9}>{name}</Typography>;
      $[18] = name;
      $[19] = t10;
    } else {
      t10 = $[19];
    }
    let t11;
    if ($[20] !== userPage?.jobTitle) {
      t11 = userPage?.jobTitle && <Typography variant="textExtraSmall" sx={{
        color: "text.primary"
      }}>{userPage?.jobTitle}</Typography>;
      $[20] = userPage?.jobTitle;
      $[21] = t11;
    } else {
      t11 = $[21];
    }
    let t12;
    if ($[22] !== t10 || $[23] !== t11 || $[24] !== t8) {
      t12 = <Box sx={t8}>{t10}{t11}</Box>;
      $[22] = t10;
      $[23] = t11;
      $[24] = t8;
      $[25] = t12;
    } else {
      t12 = $[25];
    }
    if ($[26] !== t12 || $[27] !== t7) {
      t4 = <Box sx={t6}>{t7}{t12}</Box>;
      $[26] = t12;
      $[27] = t7;
      $[28] = t4;
    } else {
      t4 = $[28];
    }
    t5 = userExperiences && <><Box sx={{
        display: "flex",
        alignItems: "center",
        gap: 2,
        mt: 2
      }}><BadgeIcon /><Typography variant="textSmallBold" sx={{
          color: "text.primary",
          lineHeight: 1
        }}>Expertise</Typography></Box><List sx={{
        listStyleType: "none",
        paddingLeft: "0.5rem",
        paddingY: 0
      }}>{userExperiences.map(_temp2)}</List></>;
    $[0] = avatarMiniatureURL;
    $[1] = maxWidth;
    $[2] = name;
    $[3] = userPage?.experience;
    $[4] = userPage?.jobTitle;
    $[5] = T0;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    T0 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
  }
  let t6;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      letterSpacing: ".03rem",
      lineHeight: 1.5,
      maxHeight: "3.75rem",
      textOverflow: "ellipsis",
      overflow: "hidden",
      color: "grey.600",
      fontSize: "0.688rem",
      mt: 1,
      WebkitLineClamp: "3",
      display: "-webkit-box",
      WebkitBoxOrient: "vertical"
    };
    $[29] = t6;
  } else {
    t6 = $[29];
  }
  let t7;
  if ($[30] !== Renderer || $[31] !== bio || $[32] !== userPage) {
    t7 = <Box sx={t6}>{userPage?.bio ? <Renderer doc={userPage.bio} /> : <Typography variant="textExtraSmall" sx={{
        color: "grey.600"
      }}>{bio}</Typography>}</Box>;
    $[30] = Renderer;
    $[31] = bio;
    $[32] = userPage;
    $[33] = t7;
  } else {
    t7 = $[33];
  }
  let t8;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      display: "flex",
      mt: 3.5,
      justifyContent: "space-between"
    };
    $[34] = t8;
  } else {
    t8 = $[34];
  }
  let t9;
  if ($[35] !== link || $[36] !== name) {
    t9 = link && <Link variant="textSmall" href={link} sx={{
      color: "secondary.main",
      justifySelf: "flex-end"
    }} aria-label={`${READ_FULL_PROFILE} for ${name}`}><Typography variant="textSmallBold" sx={{
        color: "secondary.main"
      }}>{READ_FULL_PROFILE}</Typography></Link>;
    $[35] = link;
    $[36] = name;
    $[37] = t9;
  } else {
    t9 = $[37];
  }
  let t10;
  if ($[38] !== name || $[39] !== socialMediaLinks) {
    t10 = socialMediaLinks && socialMediaLinks.length > 0 && <List sx={{
      display: "flex",
      alignItems: "center",
      gap: 1.5,
      paddingY: 0
    }}>{socialMediaLinks.map(link_0 => <ListItem key={link_0.url} sx={{
        padding: 0
      }}><SocialMediaLink iconOnly={true} {...link_0} aria-label={`Visit ${name} on ${link_0.type}`} /></ListItem>)}</List>;
    $[38] = name;
    $[39] = socialMediaLinks;
    $[40] = t10;
  } else {
    t10 = $[40];
  }
  let t11;
  if ($[41] !== t10 || $[42] !== t9) {
    t11 = <Box sx={t8}>{t9}{t10}</Box>;
    $[41] = t10;
    $[42] = t9;
    $[43] = t11;
  } else {
    t11 = $[43];
  }
  let t12;
  if ($[44] !== T0 || $[45] !== t11 || $[46] !== t2 || $[47] !== t3 || $[48] !== t4 || $[49] !== t5 || $[50] !== t7) {
    t12 = <T0 data-testid={t2} sx={t3}>{t4}{t5}{t7}{t11}</T0>;
    $[44] = T0;
    $[45] = t11;
    $[46] = t2;
    $[47] = t3;
    $[48] = t4;
    $[49] = t5;
    $[50] = t7;
    $[51] = t12;
  } else {
    t12 = $[51];
  }
  return t12;
}
function _temp2(experience_0) {
  return <ListItem key={experience_0} sx={{
    display: "list-item",
    padding: "3px 0"
  }}><Box sx={{
      display: "flex",
      alignItems: "center",
      gap: 2
    }}><Typography sx={{
        fontSize: "1.5rem",
        color: "grey.300",
        lineHeight: 0.8
      }}>•</Typography><Typography variant="textSmall" sx={{
        color: "grey.600",
        lineHeight: 1
      }}>{experience_0}</Typography></Box></ListItem>;
}
function _temp(experience) {
  const trimmed = experience.trim();
  return `${trimmed.charAt(0).toUpperCase()}${trimmed.slice(1)}`;
}